import React, { useEffect, useState } from "react";
import "./Quotationcard.css";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import ModalComponent from "../../../Components/Features/ModalComponent";
import { Images, careSupremeBenefits, productDetails } from "../../../Data/Benifits";
import {
  Modal, Box, Typography, LinearProgress, Button, TextField, Tooltip,MenuItem
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  updatedQuotationResult,
  updatePremiumPostObject,
  getHDFCTxnID,
  setSelectedProvider,
  storeQuote
} from "../../../../Redux/Health/action";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { fetchQuotationDataHelper, processQuoteData } from "../../../utils/quotationHelper";
const HdfcOptimaSecureCard = ({ collectData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productFeatures, setProductFeatures] = useState([]);
  const [premium, setPremium] = useState(null);
  const [image, setImage] = useState(null);
  const [, setIsCriticalIllness] = useState(false);
  const [criticalIllness, setCriticalIllness] = useState("");
  const [insuredAnnualIncome, setInsuredAnnualIncome] = useState("");
  // const [occupation, setOccupation] = useState(" ");
  const [selectedPlan, setSelectedPlan] = useState("");
  const [deductible, setDeductible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const premiumPostBody = useSelector(
    (state) => state?.healthReducer?.premiumPostObject
  );
  const [postBody, setPostBody] = useState(premiumPostBody);



  const handleChange = (e) => {

    collectData(e.target.checked, quote);
  };
  const generateTransactionId = () => {
    const staticTransactionId = "LMV00000";
    let dynamicSequence = Array.from({ length: 8 }, () =>
      Math.floor(Math.random() * 10)
    ).join("");
    let transactionId = staticTransactionId + dynamicSequence;
    console.log(transactionId, "transactionID");
    return transactionId;
  };
  let generatedHDFCTxnId = generateTransactionId();
  useEffect(() => {
    fetchQuotationDataHelper({
      postBody,
      provider: "hdfc",
      extraParams: {

        generatedHDFCTxnId,
      },
      selectedCoverage: premiumPostBody?.selectedCoverage,
      setLoading,
      setQuote,

    });
  }, [postBody, premiumPostBody?.selectedCoverage]);

  useEffect(() => {
    setPostBody(premiumPostBody);
  }, [premiumPostBody]);
  console.log(quote, "quotequotequote")
  const handleModal = () => {
    setModalOpen(!modalOpen);
  };
  useEffect(() => {
    if (quote) {
      processQuoteData({
        quote,
        setProductFeatures,
        setImage,
        setPremium,
        productDetails,
        Images,
        dispatch,
        storeQuote,
      });
    }
  }, [quote, dispatch]);

  const handleNavigate = (quote) => {
    let provider = quote.provider;

    let code = quote.code;
    const updatedPostBody = {
      ...postBody,
      provider: provider,
      abacusId: code,
    };


    dispatch(updatedQuotationResult(quote));
    dispatch(setSelectedProvider(provider));
    dispatch(getHDFCTxnID(generatedHDFCTxnId));
    dispatch(updatePremiumPostObject(updatedPostBody));

    navigate("/health/proposalform");

  };
  const handleSet = () => {
    setPostBody((prev) => ({
      ...prev,
      HDFC_criticalIllness_SumInsured: criticalIllness,
      HDFC_insuredAnnualIncome: insuredAnnualIncome,
      HDFC_PlanType:selectedPlan
    }));
    setOpenModal(false);
  };

  const handleCheckboxChange = (name, checked) => {
    if (
      name === "HDFC_hospitalAddons" ||
      name === "HDFC_insuredAnnualIncome" ||
      name === "HDFC_Occupation" ||
      name === "Deductible" ||
      name === "policyType"
    
    ) {
      const updatedPostBody = { ...postBody, [name]: checked };
      setPostBody(updatedPostBody);
    } else {
      const updatedPostBody = { ...postBody, [name]: checked ? true : false };
      setPostBody(updatedPostBody);
    }
 if (name === "HDFC_criticalIllness") {
    if (checked) {
      setIsCriticalIllness(true);
      setOpenModal(true); // Open modal only on check
    } else {
      setIsCriticalIllness(false);
      setCriticalIllness("");
      setInsuredAnnualIncome("");
      setSelectedPlan("");
      setPostBody((prev) => ({
        ...prev,
        HDFC_criticalIllness_SumInsured: 0,
        HDFC_insuredAnnualIncome: 1,
        HDFC_PlanType: "PLAN1",
      }));
    }
  

}
    


  };

  console.log(postBody, "postBodypostBody")
  return (
    <>
      <ModalComponent
        open={modalOpen}
        handleClose={handleModal}
        quote={quote}
        features={careSupremeBenefits}
      />
      {loading ? (
        <LinearProgress />
      ) : quote && quote?.premiumWithGST !== 0 ? (
        <div className="health_quotation_main_card  mb_25 ">
          <div className="mt-2">
            <input
              className="form-check-input"
              onChange={(e) => handleChange(e)}
              type="checkbox"
              style={{
                fontSize: "25px",
                marginLeft: "10px",
                border: "1px solid",
              }}
            />
          </div>
          <div className="d_flex quotation_upr_div">
            <div className="logo_container">
              <img src={image} alt="CARE HEALTH" className="logo_box" />
            </div>

            <div className="quotation_content">
              <div className="content_box_cs">
                <div className="plane_name plan_details">
                  <div className="title_pa">{quote?.productName}</div>
                  <div className="suminsured_text">
                    Sum Insured : ₹{quote?.sumInsured}
                  </div>
                  <b>{quote?.term || quote?.tenure} year policy</b>
                </div>

                <div className="plan_feature plan_details">
                  <div
                    className="health_check_compare"
                    style={{ marginRight: "30px" }}
                  >
                    <ul className="features_list">
                      {productFeatures?.slice(0, 4)?.map((item, i) => (
                        <li key={i} className="font-12">
                          <Tooltip title={item.benefit} placement="right-start">
                            <HealthAndSafetyIcon
                              fontSize="small"
                              style={{ marginRight: "5px", color: "#03a9f4" }}
                            />
                            <span className="font-blue">{item.feature}</span>
                          </Tooltip>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="health_check_compare">
                    <ul className="features_list">
                      {productFeatures?.slice(4, 8)?.map((item, i) => (
                        <li key={i} className="font-12">
                          <Tooltip title={item.benefit} placement="right-start">
                            <HealthAndSafetyIcon
                              fontSize="small"
                              style={{ marginRight: "5px", color: "#03a9f4" }}
                            />
                            <span className="font-blue">{item.feature}</span>
                          </Tooltip>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div onClick={() => handleNavigate(quote)} className="text_right hal_buy_btn_btn plan_details buy_btn">
                  {/* <a  className="buy_btn"> */}
                  <Tooltip title="Buy Plan" placement="bottom">
                    <span>
                      <i className="fa-solid fa-indian-rupee-sign mr_5"></i>₹{" "}
                      {premium}
                    </span>
                  </Tooltip>
                  <p>*Including GST</p>
                  <small>BUY NOW</small>
                  {/* </a> */}
                </div>
              </div>
            </div>
          </div>

          <div className="d_flex quotation_bottom_div">
            <button onClick={handleModal} className="features_btn">
              View Features <ChevronRightIcon />
            </button>
          </div>

          <div className="add_addon_div">
            <div className="d_flex addons_flex_container">
             

              <div className="health_addons_input_box">
                <label>
                  <input
                    type="checkbox"
                    name="HDFC_criticalIllness"
                    checked={(postBody?.HDFC_criticalIllness)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)}
                  />
                  <span>Critical Illness</span>
                </label>

<Modal open={openModal} onClose={() => setOpenModal(false)}>
  <Box
    sx={{
      width: 400,
      bgcolor: "background.paper",
      borderRadius: 2,
      p: 4,
      boxShadow: 24,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    }}
  >
    <Typography variant="h6" mb={2}>
      Enter Critical Illness Details
    </Typography>

    {/* Dropdown for Critical Illness Plan */}
    <TextField
      select
      label="Select Plan"
      fullWidth
      margin="normal"
      value={selectedPlan}
      onChange={(e) => setSelectedPlan(e.target.value)}
    >
      <MenuItem value="PLAN1">PLAN1 - 9 Critical Illnesses</MenuItem>
      <MenuItem value="PLAN2">PLAN2 - 12 Critical Illnesses</MenuItem>
      <MenuItem value="PLAN3">PLAN3 - 15 Critical Illnesses</MenuItem>
      <MenuItem value="PLAN4">PLAN4 - 18 Critical Illnesses</MenuItem>
      <MenuItem value="PLAN5">PLAN5 - 25 Critical Illnesses</MenuItem>
      <MenuItem value="PLAN6">PLAN6 - 40 Critical Illnesses</MenuItem>
      <MenuItem value="PLAN7">PLAN7 - 51 Critical Illnesses</MenuItem>
    </TextField>

    {/* Progress Bar: Fill based on CI vs Base SI */}
    <LinearProgress
      variant="determinate"
      value={
        postBody?.selectedCoverage && criticalIllness
          ? Math.min((criticalIllness / (postBody?.selectedCoverage * 100000)) * 100, 100)
          : 0
      }
      sx={{ mb: 2 }}
    />

    <TextField
      label="Critical Illness Sum Insured"
      type="number"
      fullWidth
      margin="normal"
      value={criticalIllness}
      onChange={(e) => setCriticalIllness(Number(e.target.value))}
      error={
        criticalIllness > postBody?.selectedCoverage * 100000 ||
        criticalIllness < 100000 ||
        criticalIllness > 20000000 ||
        criticalIllness % 1000 !== 0
      }
      helperText={
        criticalIllness < 100000 || criticalIllness > 20000000
          ? "CI SI should be between ₹1L and ₹2Cr"
          : criticalIllness % 1000 !== 0
          ? "CI SI should be a multiple of 1000"
          : criticalIllness > postBody?.selectedCoverage * 100000
          ? "CI SI should not exceed Base SI"
          : ""
      }
    />

    <TextField
      label="Annual Income"
      type="number"
      fullWidth
      margin="normal"
      value={insuredAnnualIncome}
      onChange={(e) => setInsuredAnnualIncome(Number(e.target.value))}
    />

    <Button
      variant="contained"
      fullWidth
      sx={{ mt: 2 }}
      onClick={handleSet}
      disabled={
        !selectedPlan ||
        !criticalIllness ||
        !insuredAnnualIncome ||
        criticalIllness < 100000 ||
        criticalIllness > 20000000 ||
        criticalIllness % 1000 !== 0 ||
        criticalIllness > postBody?.selectedCoverage * 100000
      }
    >
      Set
    </Button>
  </Box>
</Modal>


              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    type="checkbox"
                    name="IsUnlimitedRestore"
                    checked={Number(postBody?.IsUnlimitedRestore)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                  />
                  <span>Unlimited Restore</span>
                </label>
              </div>

              <div
                className="health_addons_input_box"
                style={{ marginBottom: "20px" }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >

                  <input
                    type="checkbox"
                    name="IsIPARider"
                    checked={Number(postBody?.IsIPARider)}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }
                    style={{ transform: "scale(1.2)", cursor: "pointer" }}
                  />
                  <span>Personal Accident Rider</span>
                </label>
              
              </div>


              {quote?.OPD && (

                <div className="health_addons_input_box">
                  <label>
                    <input
                      type="checkbox"
                      name="IsOptimaWellbeing"
                      checked={Number(postBody?.IsOptimaWellbeing)}
                      onChange={(e) =>
                        handleCheckboxChange(e.target.name, e.target.checked)
                      }
                    />
                    <span>OptimaWellbeing</span>
                  </label>
                </div>

              )}


              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={Number(postBody?.IsHDCRider)}
                    type="checkbox"
                    name="IsHDCRider"
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.checked)
                    }

                  />

                  <span>Hospital Cash</span>
                </label>
                {postBody?.IsHDCRider && (
                  <>
                    <div style={{ display: "flex", flexDirection: "row", gap: "7px" }}>
                      <div className="health_addons_input_box">
                        <label>
                          <input
                            type="checkbox"
                            name="isHDCRiderGlobal"
                            checked={Number(postBody?.isHDCRiderGlobal)}
                            onChange={(e) =>
                              handleCheckboxChange(e.target.name, e.target.checked)
                            }
                          />
                          <span> HDC Global</span>
                        </label>
                      </div>

                      <select
                        name="HDFC_hospitalAddons"
                        value={postBody?.HDFC_hospitalAddons}
                        onChange={(e) =>
                          handleCheckboxChange(e.target.name, e.target.value)
                        }
                        style={{ height: "20px", width: "55px" }}
                      >
                        <option value={0}>0</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                        <option value={1500}>1500</option>
                        <option value={2000}>2000</option>
                      </select>
                    </div>
                  </>

                )}
              </div>

              <div className="health_addons_input_box">
                <label>
                  <input
                    checked={deductible}
                    type="checkbox"
                    name="deductible"
                    onChange={(e) => {
                      setDeductible((prv) => !prv); // first
                      if (deductible && postBody?.Deductible !== 0) {
                        setPostBody((prv) => ({
                          ...prv,
                          Deductible: 0,
                        }));
                      }
                    }}
                  />

                  <span>Deductible</span>
                </label>
                {deductible && (
                  <select
                    name="Deductible"
                    value={postBody?.Deductible}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value="0">0</option>
                    <option value="25000">25000</option>
                    <option value="50000">50000</option>
                    <option value="100000">100000</option>
                    <option value="200000">200000</option>
                    <option value="300000">300000</option>
                    {premiumPostBody?.selectedCoverage>="25" &&(
 <option value="500000">500000</option>
                    )}
                   
                  </select>
                )}
              </div>





              {premiumPostBody.noOfPeople > "1" && (
                <div style={{ marginLeft: "10px" }} >

                  <select
                    name="policyType"
                    value={postBody?.policyType}
                    onChange={(e) =>
                      handleCheckboxChange(e.target.name, e.target.value)
                    }
                  >
                    <option value="">PolicyType</option>
                    <option value="Individual">Family Individual</option>
                    <option value="Floater">Family</option>
                  </select>
                </div>

              )}

            </div>
          </div>

        </div>
      ) : null}
    </>
  );
};

export default HdfcOptimaSecureCard;
